// extracted by mini-css-extract-plugin
export var addButton = "_nb-0";
export var border = "_nb-8";
export var check = "_nb-h";
export var danger = "_nb-6";
export var dropdownContainer = "_nb-1";
export var editModalBody = "_nb-j";
export var footerContainer = "_nb-i";
export var fullWidth = "_nb-a";
export var hide = "_nb-9";
export var icon = "_nb-3";
export var input = "_nb-7";
export var inputFlex = "_nb-b";
export var inputWrapper = "_nb-c";
export var manualFocus = "_nb-5";
export var optionButton = "_nb-4";
export var pillWrapper = "_nb-e";
export var pointer = "_nb-2";
export var showOverflow = "_nb-f";
export var tagsFlex = "_nb-d";
export var xButton = "_nb-g";